export const color = {
	primary: '#4bf0d2',
	secondary: '#ffffff',
	tertiary: '#afa0d7',
	headerLogo: '#ff8c87',
	tertiatyOne: 'rgba(111,113,116,.2)',

	blackOne: '#000',
	blackTwo: '#43484D',

	buttonNextBgColor: '#afa0d7',
	buttonNextTextColor: '#ffffff',
	buttonNextMobileColor: '#afa0d7',
	buttonNextMobileTextColor: '#000',
	buttonNextBorderColor: '#afa0d7',
	buttonNextMobileBorderColor: '#afa0d7',
	buttonNextHoverBgColor: '#ffffff',
	buttonNextHoverTextColor: '#afa0d7',
	buttonNextHoverBorderColor: '#afa0d7',

	buttonBackBgColor: '#ffffff',
	buttonBackTextColor: '#040505',
	buttonBackMobileBgColor: '#040505',
	buttonBackMobileTextColor: '#000',
	buttonBackBorderColor: '#040505',
	buttonBackMobileBorderColor: '#040505',
	buttonBackHoverBgColor: '#040505',
	buttonBackHoverTextColor: '#fff',
	buttonBackHoverBorderColor: '#040505',

	exchangeSelectBtnTextColor: '#ffffff',
	exchangeSelectBtnBgColor: 'rgba(111,113,116,.2)',
	exchangeSelectBtnBorderColor: 'rgba(111,113,116,.2)',
	exchangeSelectBtnBorderSize: '2px',
	exchangeSelectBtnSVGColor: '#ffffff',

	exchangeDontSelectBtnTextColor: '#ffffff',
	exchangeDontSelectBtnBgColor: '#000000',
	exchangeDontSelectBtnBorderColor: '#000000',
	exchangeDontSelectBtnBorderSize: '2px',
	exchangeDontSelectBtnSVGColor: '#ffffff',

	exchangeRemoveSelectBtnTextColor: '#ffffff',
	exchangeRemoveSelectBtnBgColor: '#000000',
	exchangeRemoveSelectBtnBorderColor: '#000000',
	exchangeRemoveSelectBtnBorderSize: '2px',
	exchangeRemoveSelectBtnSVGColor: '#ffffff',

	flowButtonSelectedTextColor: '#ffffff',
	flowButtonSelectedBgColor: '#000000',
	flowButtonSelectedBorderColor: '#000000',

	flowButtonOriginalTextColor: '#000000',
	flowButtonOriginalBgColor: '#ffffff',
	flowButtonOriginalBorderColor: '#000000',

	grayOne: '#E6E6E6',
	grayTwo: '#f7f7f7',
	grayThree: '#666',
	grayFour: '#C4C4C4',
	grayFive: '#DCDCDC',
	graySix: '#A6A6A6',
	graySeven: '#F1F1F1',
	grayEight: '#F5F5F5',
	grayTen: '#666666',
	grayEleven: '#EDEDED',
	grayTwelve: '#E6E6E6',
	grayThirteen: '#DADADA',
	grayFourteen: '#696969',
	grayFifteen: '#E5E5E5',
	graySixteen: '#E2E2E2',
	graySeventeen: '#D3D3D3',
	grayEighteen: '#5E5E5E',
	grayNineteen: '#A1A1A1',

	greenTwo: '#D7F2EA',
	greenThree: '#D7F2EA',
	greenFour: 'rgba(45,205,178,0.2)',

	redOne: '#EA0000',
	redTwo: '#F32727',
}
